import React from 'react';
import {COLORS, Image, Line, Typography} from '@fupa/fupa-uikit';
import {convertToRoman} from 'app/helpers/convertToRoman';
import {Content, Container, Stat, TeamImage, Team, RankStat} from 'app/components/standings/StandingsStyles';
import {LinkOnComponent} from 'app/components/links/link';
import {StyledTypography} from 'app/styles/content';
import {KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material';
import FormStandingStats from 'app/components/standings/FormStandingStats';

const StandingsRow = ({team, homeTeamSlug, awayTeamSlug, gameType, view}) => {
  // Workaround to prevent crashes by invalid api response sending standing infos without team ref
  if (!team.team) {
    return null;
  }

  let flag = '';
  let origin = '';
  if (gameType === 'league') {
    origin =
      team.team.origin === 'up' ? (
        <span>&nbsp;(Auf)</span>
      ) : team.team.origin === 'relegated' ? (
        <span>&nbsp;(Ab)</span>
      ) : null;
  }

  const flags = {
    withdraw: 'zg.',
    outofcompetition: 'o.W.',
  };
  if (team.team.flags?.length) {
    const values = team.team.flags.map(flag => flags[flag]);
    const text = values.join(' ');
    flag = <span>&nbsp;({text})</span>;
  }
  const TeamName =
    team.team.level > 1 ? team.team.name.middle + ' ' + convertToRoman(team.team.level) : team.team.name.middle;
  const showLine = team.mark ? null : <Line />;
  const penalty = team?.penaltyPoints && gameType === 'league' ? <span>&nbsp;*</span> : null;

  const checkTeam = team.team.slug === homeTeamSlug || team.team.slug === awayTeamSlug;
  const nameVariant = checkTeam ? 'body-strong' : team.clubSlug === 'dummy' ? 'body2' : 'body1';

  const lastResults = team?.lastResults || [];
  const reverseLastResults = [...lastResults].reverse();
  const statsRow =
    view === 'form' ? (
      <FormStandingStats lastResults={reverseLastResults} points={team.points} />
    ) : (
      <>
        <Stat align='center' minWidth={32}>
          <Typography variant='body1'>{team.matches}</Typography>
        </Stat>
        <Stat conditional align='center' minWidth={56}>
          <Typography variant='body1'>
            {team.wins}-{team.draws}-{team.defeats}
          </Typography>
        </Stat>
        <Stat conditional align='center' minWidth={56}>
          <Typography variant='body1'>
            {team.ownGoals}:{team.againstGoals}
          </Typography>
        </Stat>
        <Stat align='center' minWidth={32}>
          <Typography variant='body1'>{team.goalDifference}</Typography>
        </Stat>
        <Stat align='center' minWidth={32}>
          <Typography variant='body1'>{team.points}</Typography>
        </Stat>
      </>
    );
  const difference = team.rankWeekBefore - team.rank;
  const rankChange =
    difference < 0 ? (
      <KeyboardArrowDown style={{color: COLORS.darkGrey, fontSize: 16}} />
    ) : difference > 0 ? (
      <KeyboardArrowUp style={{color: COLORS.fupaSecondary, fontSize: 16}} />
    ) : (
      ''
    );

  const Row = (
    <Container live={team.live} mark={team.mark}>
      <RankStat align='left' minWidth={24}>
        <Typography variant='body1'>{team.rank}.</Typography>
      </RankStat>
      <RankStat align='left' minWidth={24}>
        {rankChange}
      </RankStat>
      <TeamImage>
        <Image entity='emblem' src={team.team.image} width={24} height={24} fit={true} />
      </TeamImage>
      <Team>
        <StyledTypography variant={nameVariant} useOverflow>
          {TeamName}
        </StyledTypography>
        <Typography variant={nameVariant}>
          {flag}
          {origin}
          {penalty}
        </Typography>
      </Team>
      {statsRow}
    </Container>
  );

  const content =
    team.team.clubSlug === 'dummy' ? Row : <LinkOnComponent to={`/team/${team.team.slug}`}>{Row}</LinkOnComponent>;

  return (
    <Content>
      {content}
      {showLine}
    </Content>
  );
};

export default StandingsRow;
